import { API_URL } from '../../../app-config/constants';
import Feature, { FeatureSetting } from '../../../types/Feature';
import { get, put } from '../request';

const BASE = `${API_URL}/feature-flag`;

getForCompany.operation = 'READ';
export function getForCompany(companyId: string) {
    return get<FeatureSetting[]>(`${BASE}/${companyId}`);
}

getForCompanies.operation = 'NO_OPERATION';
export function getForCompanies(featureId: Feature['id'], companyIds: string[]) {
    return get<(FeatureSetting | null)[]>(`${BASE}`, {
        getData: { companyId: companyIds.join(','), feature: featureId },
    });
}

updateFlags.operation = 'NO_OPERATION';
export function updateFlags(companyId: string, flags: FeatureSetting[]) {
    return put<FeatureSetting[]>(`${BASE}/${companyId}`, { postData: flags });
}

updateFlag.operation = 'UPDATE';
export function updateFlag(flag: FeatureSetting) {
    return Promise.resolve(flag);
}

updateFeatureForCompanies.operation = 'NO_OPERATION';
export function updateFeatureForCompanies(featureId: Feature['id'], companyIds: string[], enabled: boolean) {
    return put<FeatureSetting[]>(`${BASE}/all-known/${featureId}`, {
        postData: {
            companyIds,
            enabled,
        },
    });
}
